/* eslint-disable */
'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var reactHelmet = require('react-helmet');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function BrowserCompatibilityWarning() {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-wrapper",
    id: "page-shell-compatibility-warning",
    style: {
      display: 'none'
    },
    "data-swiftype-index": "false"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-py12 shell-px24 shell-bg-pink shell-color-white shell-align-l"
  }, /*#__PURE__*/React__default["default"].createElement("button", {
    className: "shell-absolute shell-top shell-right shell-p12",
    id: "page-shell-compatibility-dismiss"
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    className: "shell-icon",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.8,5C5.4,5,5,5.4,5,5.8C5,6,5.1,6.2,5.3,6.3l0,0L7.9,9l-2.6,2.6C5.1,11.8,5,12,5,12.2C5,12.6,5.4,13,5.8,13 c0.2,0,0.4-0.1,0.6-0.3L9,10.1l2.6,2.6c0.1,0.2,0.4,0.3,0.6,0.3c0.4,0,0.8-0.4,0.8-0.8c0-0.2-0.1-0.4-0.2-0.6L10.1,9l2.6-2.7 C12.9,6.2,13,6,13,5.8C13,5.4,12.6,5,12.2,5c-0.2,0-0.4,0.1-0.6,0.2L9,7.8L6.4,5.2C6.2,5.1,6,5,5.8,5L5.8,5z"
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "wmax1800 w-11/12-mm w-11/12-ml mx-auto px24 px0-mm shell-block shell-relative"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "compatibility-warning-copy shell-mb6 shell-align-center shell-txt-bold"
  }, "You are using an outdated browser and will encounter some problems with our website. Please consider upgrading."), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "compatibility-warning-action shell-align-center"
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    className: "shell-btn shell-btn--white shell-color-pink shell-txt-nowrap",
    href: "https://bestvpn.org/outdatedbrowser/en"
  }, "Upgrade Now")))));
}

function PageHelmet() {
  return /*#__PURE__*/React__default["default"].createElement(reactHelmet.Helmet, null, /*#__PURE__*/React__default["default"].createElement("meta", {
    charSet: "utf-8"
  }), /*#__PURE__*/React__default["default"].createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1"
  }), /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: "https://static-assets.mapbox.com/branding/favicon/v1/apple-touch-icon.png?v=gAd4JjrGWl"
  }), /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: "https://static-assets.mapbox.com/branding/favicon/v1/favicon-32x32.png?v=gAd4JjrGWl"
  }), /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: "https://static-assets.mapbox.com/branding/favicon/v1/favicon-16x16.png?v=gAd4JjrGWl"
  }), /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "manifest",
    href: "https://static-assets.mapbox.com/branding/favicon/v1/site.webmanifest?v=gAd4JjrGWl"
  }), /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "mask-icon",
    href: "https://static-assets.mapbox.com/branding/favicon/v1/safari-pinned-tab.svg?v=gAd4JjrGWl",
    color: "#4264fb"
  }), /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "shortcut icon",
    href: "https://static-assets.mapbox.com/branding/favicon/v1/favicon.ico?v=gAd4JjrGWl"
  }), /*#__PURE__*/React__default["default"].createElement("meta", {
    name: "msapplication-TileColor",
    content: "#ffffff"
  }), /*#__PURE__*/React__default["default"].createElement("meta", {
    name: "msapplication-config",
    content: "https://static-assets.mapbox.com/branding/favicon/v1/browserconfig.xml?v=gAd4JjrGWl"
  }), /*#__PURE__*/React__default["default"].createElement("meta", {
    name: "theme-color",
    content: "#ffffff"
  }), /*#__PURE__*/React__default["default"].createElement("meta", {
    name: "p:domain_verify",
    content: "57838af58c8045c2c024bc2f9d1577f9"
  }), /*#__PURE__*/React__default["default"].createElement("meta", {
    name: "google-site-verification",
    content: "umPiCFUc_EX8CJ7xWQDPgQwApDxNi59w6riFZPNZj4w"
  }), /*#__PURE__*/React__default["default"].createElement("meta", {
    name: "twitter:site",
    content: "@Mapbox"
  }), /*#__PURE__*/React__default["default"].createElement("meta", {
    property: "og:site_name",
    content: "Mapbox"
  }));
}

function NavigationItem(props) {
  var colorBasedClasses = props.darkText ? 'shell-navigation-menu-button shell-color-gray-dark shell-color-blue-on-hover' : 'shell-navigation-menu-button shell-link shell-link--white';
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-mx6 shell-mx18-mxl",
    style: {
      lineHeight: 1
    }
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    className: "shell-py6 shell-txt-s shell-txt-bold ".concat(colorBasedClasses),
    href: props.href
  }, props.children));
}

NavigationItem.propTypes = {
  darkText: PropTypes__default["default"].bool,
  href: PropTypes__default["default"].string.isRequired,
  children: PropTypes__default["default"].string.isRequired
};

function MobileMenuButton(props) {
  var menuButtonClasses = 'shell-block';

  if (!props.darkText) {
    menuButtonClasses += ' shell-link shell-link--white';
  } else {
    menuButtonClasses += ' shell-color-blue';
  }

  return /*#__PURE__*/React__default["default"].createElement("button", {
    id: "mobile-nav-trigger-toggle",
    "aria-label": "Toggle navigation",
    className: menuButtonClasses,
    "data-test": "mobile-nav-trigger-toggle"
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    id: "mobile-nav-trigger-menu",
    viewBox: "0 0 18 18",
    className: "shell-mobile-nav__trigger shell-icon shell-transition shell-icon--l"
  }, /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("path", {
    className: "shell-mobile-nav__trigger__bar--top",
    d: "M4.2,6h9.6C14.5,6,15,5.6,15,5s-0.5-1-1.2-1H4.2C3.5,4,3,4.4,3,5S3.5,6,4.2,6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    className: "shell-mobile-nav__trigger__bar--middle",
    d: "M13.8,8H4.2C3.5,8,3,8.4,3,9s0.5,1,1.2,1h9.6c0.7,0,1.2-0.4,1.2-1S14.5,8,13.8,8z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    className: "shell-mobile-nav__trigger__bar--bottom",
    d: "M13.8,12H4.2C3.5,12,3,12.4,3,13s0.5,1,1.2,1h9.6c0.7,0,1.2-0.4,1.2-1S14.5,12,13.8,12z"
  }))));
}

MobileMenuButton.propTypes = {
  darkText: PropTypes__default["default"].bool
};

var language = "en";
var logoSiteTitle = "Docs";
var all = "All docs";
var homepage = "https://www.mapbox.com";
var nav = [
	{
		title: "Maps",
		href: "https://docs.mapbox.com/#maps"
	},
	{
		title: "Navigation",
		href: "https://docs.mapbox.com/#navigation"
	},
	{
		title: "Search",
		href: "https://docs.mapbox.com/#search"
	},
	{
		title: "Vision",
		href: "https://docs.mapbox.com/#vision"
	},
	{
		title: "Data",
		href: "https://docs.mapbox.com/#data"
	},
	{
		title: "Help",
		href: "https://docs.mapbox.com/help/"
	}
];
var navigationMenuData = {
	language: language,
	logoSiteTitle: logoSiteTitle,
	all: all,
	homepage: homepage,
	nav: nav
};

var ORIGIN_DOCS_PRODUCTION = 'https://docs.mapbox.com';
var DEFAULT_SOCIAL_IMAGE_URL = 'https://static-assets.mapbox.com/branding/social/social-1200x630.v2.jpg';
var DEFAULT_SOCIAL_IMAGE_THUMBNAIL_URL = 'https://static-assets.mapbox.com/branding/social/social-120x120.v2.png';

var MOBILE_HEADER_HEIGHT = 72;

function MobileNavigation() {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-z1 shell-absolute shell-top shell-left shell-right shell-w-full"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    id: "mobile-nav-backdrop",
    "data-test": "mobile-nav-backdrop",
    className: "shell-absolute shell-bottom shell-left shell-right shell-mobile-nav__backdrop",
    style: {
      top: MOBILE_HEADER_HEIGHT,
      backgroundImage: "linear-gradient(to bottom, transparent, rgba(31, 51, 73, .5))"
    }
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "mobile-nav-menu",
    "data-test": "mobile-nav-menu",
    className: "shell-absolute shell-z5 shell-w-full shell-animated-menu",
    style: {
      top: 0,
      right: 0
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-shadow-darken10-bold shell-bg-white shell-overflow-hidden shell-px24",
    style: {
      paddingTop: MOBILE_HEADER_HEIGHT
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-pb24"
  }, navigationMenuData.nav.map(function (nav) {
    return /*#__PURE__*/React__default["default"].createElement("a", {
      key: nav.href,
      href: nav.href,
      className: "block shell-py6"
    }, nav.title);
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-border-t shell-border--gray-light shell-py24"
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: ORIGIN_DOCS_PRODUCTION,
    className: "shell-color-blue"
  }, navigationMenuData.all)))));
}

function Logo(props) {
  var darkText = props.darkText,
      mini = props.mini;
  var logoClasses = 'shell-mb-logo';

  if (!darkText) {
    logoClasses += ' shell-mb-logo--white';
  }

  var logoStyles = {};

  if (mini) {
    logoStyles.width = 30;
    logoStyles.height = 42;
    logoStyles.backgroundSize = '132px 42px';
  }

  var border = null;

  if (!mini) {
    var borderClasses = 'shell-h24 shell-mx12';
    borderClasses += darkText ? ' shell-bg-blue' : ' shell-bg-white';
    border = /*#__PURE__*/React__default["default"].createElement("div", {
      className: borderClasses,
      style: {
        width: 2
      },
      "data-subtitle-bar-dark": darkText
    });
  }

  var nameClasses = 'shell-txt-bold ';
  nameClasses += 'shell-txt-l ';
  nameClasses += darkText ? ' shell-color-blue shell-color-blue-dark-on-hover' : ' shell-link shell-link--white';

  if (mini) {
    nameClasses += ' shell-ml6';
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-flex shell-flex--center-cross"
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: navigationMenuData.homepage,
    "aria-label": "Mapbox",
    className: logoClasses,
    style: logoStyles
  }), border, /*#__PURE__*/React__default["default"].createElement("a", {
    href: ORIGIN_DOCS_PRODUCTION,
    className: nameClasses,
    style: {
      marginBottom: 2
    },
    "data-subtitle-dark": darkText
  }, navigationMenuData.logoSiteTitle));
}

Logo.propTypes = {
  darkText: PropTypes__default["default"].bool,
  mini: PropTypes__default["default"].bool
};
Logo.defaultProps = {
  darkText: false,
  mini: false
};

var USER_MENU_STYLE = {
  minWidth: 66,
  maxWidth: 120
};

function PageHeader(props) {
  var logoOverlay = null;

  if (!props.darkText) {
    logoOverlay = /*#__PURE__*/React__default["default"].createElement("div", {
      className: "shell-mobile-nav__logo--overlay shell-absolute shell-top shell-left"
    }, /*#__PURE__*/React__default["default"].createElement(Logo, {
      darkText: true,
      mini: true
    }));
  }

  return /*#__PURE__*/React__default["default"].createElement("header", {
    className: "shell-absolute shell-w-full shell-z1",
    "data-swiftype-index": "false"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-none ".concat(props.jekyll ? 'limiter' : 'wmax1800 w-11/12-mm w-11/12-ml mx-auto px24 px0-mm', " shell-mt24 shell-flex-mm shell-flex--center-cross")
  }, /*#__PURE__*/React__default["default"].createElement(Logo, {
    darkText: props.darkText
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-flex-child-grow shell-flex shell-flex--center-cross shell-flex--center-main"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-flex shell-flex--center-cross shell-flex--end-main"
  }, navigationMenuData.nav.map(function (nav) {
    return /*#__PURE__*/React__default["default"].createElement(NavigationItem, {
      key: nav.href,
      href: nav.href,
      darkText: props.darkText
    }, nav.title);
  }))), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", {
    id: "mbx-user-menu",
    style: USER_MENU_STYLE,
    "data-user-menu-trigger": true
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "page-header-content",
    className: "shell-none-mm ".concat(props.jekyll ? 'limiter' : 'wmax1800 w-11/12-mm w-11/12-ml mx-auto px24 px0-mm', " shell-py12 shell-z2 shell-relative")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-flex shell-flex--center-cross"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-flex-child-no-shrink shell-ml-neg6"
  }, /*#__PURE__*/React__default["default"].createElement(MobileMenuButton, {
    darkText: props.darkText
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-flex-child-grow shell-relative shell-mb-logo__wrapper shell-ml12"
  }, /*#__PURE__*/React__default["default"].createElement(Logo, {
    darkText: props.darkText,
    mini: true
  }), logoOverlay), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "shell-flex-child-no-shrink"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    id: "mbx-user-menu-mobile",
    style: USER_MENU_STYLE,
    "data-user-menu-trigger": true
  })))), /*#__PURE__*/React__default["default"].createElement(MobileNavigation, null));
}

PageHeader.propTypes = {
  darkText: PropTypes__default["default"].bool,
  jekyll: PropTypes__default["default"].bool
};
PageHeader.defaultProps = {
  darkText: false,
  jekyll: false
};

function FooterLegalStrip(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: props.className
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    className: "shell-link shell-color-gray shell-color-gray-dark-on-hover shell-mr18",
    href: "https://www.mapbox.com/"
  }, "\xA9 Mapbox"), /*#__PURE__*/React__default["default"].createElement("a", {
    className: "shell-link shell-color-gray shell-color-gray-dark-on-hover shell-mr18",
    href: "https://www.mapbox.com/tos/"
  }, "Terms"), /*#__PURE__*/React__default["default"].createElement("a", {
    className: "shell-link shell-color-gray shell-color-gray-dark-on-hover shell-mr18",
    href: "https://www.mapbox.com/privacy/"
  }, "Privacy"), /*#__PURE__*/React__default["default"].createElement("a", {
    className: "shell-link shell-color-gray shell-color-gray-dark-on-hover",
    href: "https://www.mapbox.com/platform/security/"
  }, "Security"));
}

FooterLegalStrip.propTypes = {
  className: PropTypes__default["default"].string
};

function FooterSocialMediaStrip(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: props.className
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    "aria-label": "Github",
    className: "shell-color-blue shell-color-blue-dark-on-hover shell-inline-block shell-w36",
    href: "https://github.com/mapbox"
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    viewBox: "0 0 14 14",
    className: "shell-icon shell-icon--s shell-inline"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7zm-9 5.7V11h-.8C3 11 2.1 9.5 2.1 8.7c0-.5.6-.7.9-.2.1.1.6 1 1.2 1 .3 0 .6-.1.9-.2.1-.3.3-.6.6-.8h-.2C4.1 8.5 3 7.4 3 6c0-.7.3-1.3.7-1.7 0-.6.1-1.1.2-1.5.1-.2.3-.3.4-.3.4.1 1.2.3 1.8.9h1.6c.7-.6 1.4-.9 1.8-.9.2 0 .4.1.4.3.1.3.2.8.2 1.3.6.5.9 1.2.9 1.9 0 1.4-1.1 2.5-2.5 2.5h-.2c.4.4.7.9.7 1.5v2.7c2.3-.8 4-3 4-5.7 0-3.3-2.7-6-6-6S1 3.7 1 7c0 2.6 1.7 4.8 4 5.7z"
  }))), /*#__PURE__*/React__default["default"].createElement("a", {
    "aria-label": "Twitter",
    className: "shell-color-blue shell-color-blue-dark-on-hover shell-inline-block shell-w36",
    href: "https://twitter.com/mapbox/"
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    viewBox: "0 0 12 10",
    className: "shell-icon shell-icon--s shell-inline"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 1.2c-.4.2-.9.4-1.4.4.5-.3.9-.8 1.1-1.4-.5.3-1 .5-1.5.6C9.8.4 9.1 0 8.4 0 7 0 5.9 1.2 5.9 2.5c0 .2 0 .4.1.5C3.9 3.1 2.1 2 .9.5.6.9.5 1.3.5 1.8c0 .9.4 1.6 1.1 2.1-.4 0-.8-.1-1.1-.4 0 1.2.9 2.2 2 2.5-.2.1-.4.1-.7.1-.2 0-.3 0-.4-.1.3 1 1.2 1.7 2.3 1.8-.9.7-1.9 1-3.1 1H0c1.1.8 2.4 1.2 3.8 1.2 4.5 0 7-3.8 7-7.1v-.4c.4-.3.9-.7 1.2-1.3z"
  }))), /*#__PURE__*/React__default["default"].createElement("a", {
    "aria-label": "LinkedIn",
    className: "shell-color-blue shell-color-blue-dark-on-hover shell-inline-block shell-w36",
    href: "https://www.linkedin.com/company/mapbox"
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    className: "shell-icon shell-icon--s shell-inline"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.68801 6.31665H0.633606V23.9998H5.68801V6.31665Z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.6832 6.31665C14.16 6.31665 13.5504 7.60305 13.2624 8.84145V6.31665H8.21277V23.9998H13.2624V13.8959C13.2624 12.2591 14.1504 11.3711 15.7872 11.3711C17.424 11.3711 18.312 12.2399 18.312 13.8959V23.9998H23.3664V15.1582C23.3664 10.1039 22.7088 6.31665 17.6832 6.31665Z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3.15841 5.0496C4.55281 5.0496 5.68321 3.91921 5.68321 2.5248C5.68321 1.13039 4.55281 0 3.15841 0C1.764 0 0.633606 1.13039 0.633606 2.5248C0.633606 3.91921 1.764 5.0496 3.15841 5.0496Z"
  }))), /*#__PURE__*/React__default["default"].createElement("a", {
    "aria-label": "Facebook",
    className: "shell-color-blue shell-color-blue-dark-on-hover shell-inline-block shell-w36",
    href: "https://www.facebook.com/Mapbox"
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    viewBox: "0 0 50 50",
    className: "shell-icon shell-icon--s shell-inline"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "38f48a9c-03c5-4a1e-8aed-38100e1cd6a4",
    "data-name": "svg"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    id: "c5d5da0e-6004-406b-ad77-825ffd134c21",
    "data-name": "f",
    d: "M28.87,50V27.19h7.65l1.15-8.89h-8.8V12.63c0-2.57.71-4.33,4.41-4.33H38v-8A63.78,63.78,0,0,0,31.13,0C24.34,0,19.69,4.14,19.69,11.75V18.3H12v8.89h7.68V50Z"
  })))), /*#__PURE__*/React__default["default"].createElement("a", {
    "aria-label": "Instagram",
    className: "shell-color-blue shell-color-blue-dark-on-hover shell-inline-block shell-w36",
    href: "https://www.instagram.com/Mapbox"
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    className: "shell-icon shell-icon--s shell-inline"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.9968 7.9983C9.79333 7.9983 7.99515 9.79651 7.99515 12C7.99515 14.2035 9.79333 16.0017 11.9968 16.0017C14.2002 16.0017 15.9984 14.2035 15.9984 12C15.9984 9.79651 14.2002 7.9983 11.9968 7.9983ZM23.9987 12C23.9987 10.3429 24.0137 8.70077 23.9206 7.04665C23.8275 5.12536 23.3893 3.4202 21.9843 2.01525C20.5764 0.607302 18.8743 0.172008 16.953 0.0789456C15.2959 -0.0141173 13.6539 0.000892936 11.9998 0.000892936C10.3427 0.000892936 8.70061 -0.0141173 7.04652 0.0789456C5.12526 0.172008 3.42014 0.610305 2.01522 2.01525C0.607291 3.42321 0.172005 5.12536 0.0789442 7.04665C-0.014117 8.70377 0.000892919 10.3459 0.000892919 12C0.000892919 13.6541 -0.014117 15.2992 0.0789442 16.9533C0.172005 18.8746 0.610293 20.5798 2.01522 21.9847C3.42314 23.3927 5.12526 23.828 7.04652 23.9211C8.70361 24.0141 10.3457 23.9991 11.9998 23.9991C13.6569 23.9991 15.2989 24.0141 16.953 23.9211C18.8743 23.828 20.5794 23.3897 21.9843 21.9847C23.3923 20.5768 23.8275 18.8746 23.9206 16.9533C24.0167 15.2992 23.9987 13.6571 23.9987 12ZM11.9968 18.1572C8.58954 18.1572 5.83973 15.4073 5.83973 12C5.83973 8.5927 8.58954 5.84284 11.9968 5.84284C15.404 5.84284 18.1538 8.5927 18.1538 12C18.1538 15.4073 15.404 18.1572 11.9968 18.1572ZM18.406 7.02864C17.6105 7.02864 16.968 6.38621 16.968 5.59067C16.968 4.79513 17.6105 4.1527 18.406 4.1527C19.2015 4.1527 19.8439 4.79513 19.8439 5.59067C19.8442 5.77957 19.8071 5.96667 19.735 6.14124C19.6628 6.31581 19.5569 6.47442 19.4233 6.608C19.2897 6.74157 19.1311 6.84748 18.9565 6.91967C18.782 6.99185 18.5949 7.02888 18.406 7.02864Z"
  }))));
}

FooterSocialMediaStrip.propTypes = {
  className: PropTypes__default["default"].string
};

function PageFooter(props) {
  return /*#__PURE__*/React__default["default"].createElement("footer", {
    id: "page-footer",
    className: "shell-py12 shell-py48-ml",
    "data-swiftype-index": "false"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: props.jekyll ? 'limiter' : 'wmax1800 w-11/12-mm w-11/12-ml mx-auto px24 px0-mm'
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    id: "page-footer-legal-social",
    className: "shell-grid shell-txt-s shell-color-gray shell-py12 shell-py0-ml"
  }, /*#__PURE__*/React__default["default"].createElement(FooterLegalStrip, {
    className: "shell-col shell-w-full shell-w-1/2-mm shell-my12"
  }), /*#__PURE__*/React__default["default"].createElement(FooterSocialMediaStrip, {
    className: "shell-col shell-w-full shell-w-1/2-mm shell-my12 shell-align-r-mm"
  }))));
}
PageFooter.propTypes = {
  jekyll: PropTypes__default["default"].bool
};
PageFooter.defaultProps = {
  jekyll: false
};

var contextlessTitles = ['Introduction', 'Overview', 'Guides'];
function titleGenerator(title, subsite, site) {
  // create array for formatted title: {title} | {subsite} | {site}
  var titleArr = []; // do not push a title that is "Introduction" or "Overview"

  if (title && contextlessTitles.indexOf(title) === -1 && (subsite || site)) titleArr.push(title); // push subsite, if same value doesn't exist yet, strip "for (Product)" from name

  if (subsite && titleArr.indexOf(subsite) === -1) titleArr.push(subsite.replace(/\sfor\s(iOS|Android|Vision|Unity)/, '')); // push site, if same value doesn't exist yet

  if (site && titleArr.indexOf(site) === -1) titleArr.push(site);
  return titleArr;
}

function MetaTagger(props) {
  var title = titleGenerator(props.title, props.subsite, props.site).join(' | ');
  var suffixedTitle = "".concat(title, " | Mapbox");
  var preppedDescription = props.description.replace(/\s+/g, ' ');
  var prodUrl = 'https://docs.mapbox.com';
  if (props.pathname[0] !== '/') prodUrl += '/';
  prodUrl += props.pathname;
  var metaItems = [{
    name: 'description',
    content: preppedDescription
  }];
  metaItems.push({
    name: 'twitter:title',
    content: title
  }, {
    property: 'og:title',
    content: title
  }, {
    name: 'twitter:description',
    content: preppedDescription
  }, {
    property: 'og:description',
    content: preppedDescription
  }, {
    property: 'og:url',
    content: prodUrl
  }, {
    property: 'og:type',
    content: 'website'
  }, {
    "class": 'swiftype',
    name: 'title',
    'data-type': 'string',
    content: props.title
  }, {
    "class": 'swiftype',
    name: 'excerpt',
    'data-type': 'string',
    content: props.description
  }, {
    name: 'twitter:image:alt',
    content: props.imageAlt
  }, {
    property: 'og:image',
    content: props.imageUrl
  }, {
    "class": 'swiftype',
    name: 'image',
    'data-type': 'enum',
    content: props.imageUrl
  }, {
    "class": 'swiftype',
    name: 'site',
    'data-type': 'string',
    content: props.site
  });

  if (props.subsite) {
    metaItems.push({
      "class": 'swiftype',
      name: 'subsite',
      'data-type': 'string',
      content: props.subsite
    });
  }

  if (props.contentType) {
    metaItems.push({
      "class": 'swiftype',
      name: 'contentType',
      'data-type': 'string',
      content: props.contentType
    });
  }

  if (props.language) {
    props.language.forEach(function (language) {
      metaItems.push({
        "class": 'swiftype',
        name: 'codeLanguage',
        'data-type': 'string',
        content: language
      });
    });
  }

  if (props.level) {
    metaItems.push({
      "class": 'swiftype',
      name: 'level',
      'data-type': 'string',
      content: props.level
    });
  }

  if (props.largeImage) {
    metaItems.push({
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:image',
      content: props.imageUrl
    });
  } else {
    metaItems.push({
      name: 'twitter:card',
      content: 'summary'
    }, {
      name: 'twitter:image',
      content: props.imageUrlThumbnail
    });
  }

  if (props.hideFromSearchEngines) {
    metaItems.push({
      name: 'robots',
      content: 'noindex, nofollow'
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(reactHelmet.Helmet, {
    title: suffixedTitle,
    meta: metaItems
  });
}

MetaTagger.propTypes = {
  title: PropTypes__default["default"].string.isRequired,
  description: PropTypes__default["default"].string.isRequired,
  pathname: PropTypes__default["default"].string.isRequired,
  site: PropTypes__default["default"].string.isRequired,
  subsite: PropTypes__default["default"].string,
  contentType: PropTypes__default["default"].string,
  imageUrl: PropTypes__default["default"].string,
  imageUrlThumbnail: PropTypes__default["default"].string,
  imageAlt: PropTypes__default["default"].string,
  largeImage: PropTypes__default["default"].bool,
  language: PropTypes__default["default"].array,
  level: PropTypes__default["default"].number,
  hideFromSearchEngines: PropTypes__default["default"].bool
};
MetaTagger.defaultProps = {
  imageUrl: DEFAULT_SOCIAL_IMAGE_URL,
  imageUrlThumbnail: DEFAULT_SOCIAL_IMAGE_THUMBNAIL_URL,
  imageAlt: 'Mapbox',
  largeImage: true
};

var lastUrl;

var ReactPageShell = /*#__PURE__*/function (_React$Component) {
  _inherits(ReactPageShell, _React$Component);

  var _super = _createSuper(ReactPageShell);

  function ReactPageShell() {
    _classCallCheck(this, ReactPageShell);

    return _super.apply(this, arguments);
  }

  _createClass(ReactPageShell, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!window.MapboxPageShell) throw new Error('MapboxPageShell not loaded');
      this.initialize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var currentUrl = window.location.href;
      if (currentUrl === lastUrl) return;
      lastUrl = currentUrl;
      this.initialize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      MapboxPageShell.removeNavigation();
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this = this;

      MapboxPageShell.initialize();
      MapboxPageShell.afterUserCheck(function () {
        if (_this.props.onUser) {
          _this.props.onUser(MapboxPageShell.getUser(), MapboxPageShell.getUserPublicAccessToken());
        }

        MapboxPageShell.loadUserMenu({
          dark: _this.props.darkHeaderText
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var nonFooterClasses = 'shell-flex-child-grow shell-flex-child-no-shrink';

      if (this.props.nonFooterBgClass) {
        nonFooterClasses += " ".concat(this.props.nonFooterBgClass);
      }

      return /*#__PURE__*/React__default["default"].createElement("div", {
        id: "page-shell"
      }, /*#__PURE__*/React__default["default"].createElement(BrowserCompatibilityWarning, null), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "shell-flex shell-flex--column",
        style: {
          minHeight: '100vh'
        }
      }, /*#__PURE__*/React__default["default"].createElement(PageHelmet, null), /*#__PURE__*/React__default["default"].createElement(MetaTagger, _extends({}, this.props.meta, {
        site: this.props.site,
        subsite: this.props.subsite
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: nonFooterClasses
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "shell-wrapper"
      }, /*#__PURE__*/React__default["default"].createElement(PageHeader, {
        darkText: this.props.darkHeaderText
      })), /*#__PURE__*/React__default["default"].createElement("main", {
        role: "main",
        style: {
          zIndex: 0,
          position: 'relative',
          display: 'block'
        }
      }, this.props.children)), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "shell-flex-child-no-shrink shell-wrapper"
      }, /*#__PURE__*/React__default["default"].createElement(PageFooter, null))));
    }
  }]);

  return ReactPageShell;
}(React__default["default"].Component);

ReactPageShell.propTypes = {
  meta: PropTypes__default["default"].shape({
    title: PropTypes__default["default"].string.isRequired,
    description: PropTypes__default["default"].string.isRequired,
    contentType: PropTypes__default["default"].string,
    pathname: PropTypes__default["default"].string,
    level: PropTypes__default["default"].number,
    codeLanguage: PropTypes__default["default"].array,
    hideFromSearchEngines: PropTypes__default["default"].bool
  }).isRequired,
  children: PropTypes__default["default"].node.isRequired,
  site: PropTypes__default["default"].string.isRequired,
  subsite: PropTypes__default["default"].string,
  darkHeaderText: PropTypes__default["default"].bool,
  nonFooterBgClass: PropTypes__default["default"].string,
  onUser: PropTypes__default["default"].func
};
ReactPageShell.defaultProps = {
  darkHeaderText: false
};

module.exports = ReactPageShell;
